import React, { Component } from 'react';
import { Box } from '@mui/material';
import { Col, Row, Container } from 'reactstrap';
import Applications from './Applications';
import Featured from './Featured';
import Head from './Head';
import SwapBanner from '../common/SwapBanner';
import { SHOW_BANNER_MAINTENANCE } from '../common/constants';
import BannerMaintenance from '../Dashboard/Banners/BannerMaintenance';

class Landing extends Component {
  state = {};

  render() {
    return (
      <React.Fragment>
        {/* <SwapBanner className="landing"/> */}

        {SHOW_BANNER_MAINTENANCE && (
          <Box sx={{ px: 1 }}>
            <BannerMaintenance />
          </Box>
        )}
        <Container fluid className="myOdu__appContentWrapper landing myOdu__landing">
          <Row className="head">
            <Col>
              <Head />
            </Col>
          </Row>
          {/* <Row><Col><Featured /></Col></Row> */}
          {/* <hr/> */}
          <Row className="mt-5">
            <Col>
              <Applications />
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default Landing;
